module.exports = __webpack_public_path__ + "static/media/blog_img_placeholder01.5f8a9057.jpg";